import { ChargeSchedule } from '.'

export function generateLimitsText(chargeSchedule?: ChargeSchedule) {
  if (!chargeSchedule) {
    return 'Charge limits are not currently controllable for this vehicle'
  }

  return `Min - ${chargeSchedule.battery_target_min}%, Max - ${chargeSchedule.battery_target_max}%`
}
